import AzeriteEssences from 'shared/data/live/azerite-essences.json';
import BonusAffixNames from 'shared/data/live/bonus-affix-names.json';
import BonusLevels from 'shared/data/live/bonus-id-levels.json';
import BonusSockets from 'shared/data/live/bonus-sockets.json';
import BonusEffects from 'shared/data/live/bonus-effects.json';
import Conduits from 'shared/data/live/conduits.json';
import ConduitRanks from 'shared/data/live/conduit-ranks.json';
import Covenants from 'shared/data/live/covenants.json';
import EncounterNames from 'shared/data/live/encounter-names.json';
import InstanceNames from 'shared/data/live/instance-names.json';
import Instances from 'shared/data/live/instances.json';
import LegendaryAbilities from 'shared/data/live/legendary-abilities.json';
import Talents from 'shared/data/live/talents.json';

export default {
  AzeriteEssences,
  BonusAffixNames,
  BonusEffects,
  BonusLevels,
  BonusSockets,
  Conduits,
  ConduitRanks,
  Covenants,
  EncounterNames,
  InstanceNames,
  Instances,
  LegendaryAbilities,
  Talents,
};
